import React from "react";
import Weather from "./Weather";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header"></header>
      <div>
        <Weather defaultCity="Tehran" />
      </div>
      <footer>
        Website coded by Vandah Taghdisi
        <br />
        <a href="https://github.com/noisykilljoy/react-weather-app">
          Click here for Github Repo
        </a>
      </footer>
    </div>
  );
}

export default App;
